import { Directive, OnInit, ElementRef, inject } from '@angular/core';

import { HisBaseGlobalsService } from '../../core/service/base/his-base-globals.service';
import { HisPlamComponent } from '../../structure/component/plam/his-plam.component';


@Directive( {
    exportAs: '.noPlamStyle',
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: '.noPlamStyle',
    standalone: false
} )
export class HisPlamDirective implements OnInit {
    elementRef = inject(ElementRef);
    hisBaseGlobalsService = inject(HisBaseGlobalsService);
    private hisPlamRef = inject(HisPlamComponent, { optional: true });


    ngOnInit(): void {
        if(this.hisPlamRef) {
            this.hisPlamRef.noPlamStyle = true;
        }
    }


}
